import fetch from 'cross-fetch';

/**
 * Enables RTK-query to run server-side. Usage:
 *
 * <code>baseQuery: fetchBaseQuery({ fetchFn })</code>
 */
export const fetchFn = (requestInfo: RequestInfo) => {
    return typeof requestInfo === 'string'
        ? fetch(requestInfo)
        : fetch(requestInfo.url, requestInfo);
};